/* eslint-disable import/prefer-default-export */
export const ALTERNATIVE_DISPLAY_SUBSCRIBER = ["1.2.250.1.183.1.1.0.0", "1.2.250.1.183.1.0.0.0"];
